import gql from "graphql-tag";

export const HOLD_STRIPE_CARD = gql`
  mutation holdStripeCard($createPaymentInputHoldCard: CreatePaymentInputHoldCard!) {
    holdStripeCard(createPaymentInputHoldCard: $createPaymentInputHoldCard) {
      id
    }
  }
`;
